import { Query } from '@apollo/client/react/components'

import { relayConnectionToArray } from 'utils/transformations/graphql'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'
import { getCollectionsFormatted } from 'shop/formatters'

export const MINIMUM_CHARACTERS_QUERY = 2

const collectionsQuery = atlas`#graphql
  query CollectionsQueryDupe5(
    $brandIds: [ID!]
    $orderBy: CollectionOrderByField
  ) {
    collections(
      brandIds: $brandIds
      filters: { archived: false }
      orderBy: { field: $orderBy }
    ) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const shouldSkipCollectionQuery = (props) => {
  const { isLiteRetailer, brandId, isAccountTypeRetailer } = props

  if (isAccountTypeRetailer) {
    return !isLiteRetailer || !brandId
  }

  return false
}

export const withCollections = (WrappedComponent) => (props) => {
  const { brandId, isAccountTypeRetailer } = props

  const variables = {
    brandIds: isAccountTypeRetailer && brandId ? [brandId] : [],
    orderBy: 'POSITION',
  }

  return (
    <Query
      client={atlasClient}
      query={collectionsQuery}
      variables={variables}
      skip={shouldSkipCollectionQuery({
        ...props,
      })}
    >
      {({ loading, error, data }) => {
        const customProps = {
          ...props,
          collectionsLoading: loading,
          collections:
            !loading && !error && data
              ? getCollectionsFormatted(
                  relayConnectionToArray(data.collections),
                )
              : getCollectionsFormatted([]),
        }
        return <WrappedComponent {...customProps} />
      }}
    </Query>
  )
}
